/**
 * SubCategoryRow.js
 * Written by: Alex Kasemir
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import StartQuizButton from 'components/StartQuizButton';
import StartPercentText from 'components/StartPercentText';

import {
  SubCategoryRowContainer,
  QuizName,
  QuizRow,
  QuizButtons,
  ScoreRow,
  ScoreSection,
  ScoreLabel,
} from './SubCategoryRow.styles';

/**
 * View you submitted questions
 *
 */
export class SubCategoryRow extends Component {
  render() {
    const { subcategory, authedUserId } = this.props;
    if (subcategory.quizzes.length === 0) {
      return null;
    }
    return (
      <SubCategoryRowContainer>
        <QuizRow>
          <QuizName>{subcategory.name}</QuizName>
          {
            subcategory.quizzes.length === 3
              ? <QuizButtons>
                <StartQuizButton
                  quiz={subcategory.quizzes.find((q) => q.kind === `E`)}
                />
                <StartQuizButton
                  quiz={subcategory.quizzes.find((q) => q.kind === `M`)}
                />
                <StartQuizButton
                  quiz={subcategory.quizzes.find((q) => q.kind === `H`)}
                />
              </QuizButtons>
              : <QuizButtons kind="S">
                <StartQuizButton
                  quiz={subcategory.quizzes[0]}
                />
              </QuizButtons>
          }
        </QuizRow>
        <ScoreRow >
          <ScoreLabel type="label">
            {authedUserId ? `SCORE:` : `SCORE: Login to start tracking scores`}
          </ScoreLabel>
          {authedUserId ? subcategory.quizzes.length === 3
            ? (<ScoreSection>
              <StartPercentText
                quiz={subcategory.quizzes.find((q) => q.kind === `E`)}
              />
              <StartPercentText
                quiz={subcategory.quizzes.find((q) => q.kind === `M`)}
              />
              <StartPercentText
                quiz={subcategory.quizzes.find((q) => q.kind === `H`)}
              />
            </ScoreSection>)
            : (<ScoreSection kind="S">
              <StartPercentText
                quiz={subcategory.quizzes[0]}
              />
            </ScoreSection>) : null}
        </ScoreRow>
      </SubCategoryRowContainer>
    );
  }
}

SubCategoryRow.propTypes = {
  subcategory: PropTypes.object.isRequired,
  authedUserId: PropTypes.number,
};

export default connect((state) => {
  return {
    authedUserId: state.user.session.authedUserId,
  };
}, {})(SubCategoryRow);
